// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","tertiary":"#BFD730","options":"_3B36","active":"_2WZ2","frame":"JBC-","frameChrome":"HuIA","dot":"_2lEB","red":"_1lt0","orange":"_1arS","green":"_388v"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ProductScreenshots/ProductScreenshots.scss
// module id = xclA
// module chunks = 0